<template>
  <div class="attachment-source-button">
    <v-menu
      v-model="menuOpen"
      bottom
      offset-y
      nudge-bottom="4"
      :disabled="disabled"
      content-class="attachment-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <button
          class="text-action-btn"
          type="button"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="15" color="#666">mdi-paperclip</v-icon>
          Adjuntar
        </button>
      </template>

      <div class="attachment-menu__panel" role="menu">
        <button
          class="attachment-menu__item"
          type="button"
          role="menuitem"
          @click="openUploader"
        >
          <span class="attachment-menu__icon">
            <v-icon size="18" color="#2D4B95">mdi-upload</v-icon>
          </span>
          <span class="attachment-menu__text">
            <span class="attachment-menu__title">Subir archivo</span>
            <span class="attachment-menu__desc">Desde tu computador</span>
          </span>
        </button>

        <button
          class="attachment-menu__item"
          type="button"
          role="menuitem"
          @click="openLibrary"
        >
          <span class="attachment-menu__icon">
            <v-icon size="18" color="#2D4B95">mdi-folder-search-outline</v-icon>
          </span>
          <span class="attachment-menu__text">
            <span class="attachment-menu__title">Seleccionar desde biblioteca</span>
            <span class="attachment-menu__desc">Archivos ya cargados</span>
          </span>
        </button>
      </div>
    </v-menu>

    <input
      ref="uploader"
      multiple
      class="d-none"
      type="file"
      @change="handleFiles"
    />

    <FileSelectorModal
      v-if="showLibrary"
      :file-filter="fileFilter"
      @select="selectLibraryFile"
      @close="showLibrary = false"
    />
  </div>
</template>

<script>
import FileSelectorModal from '@/components/Globals/Modals/General/FileSelectorModal'

export default {
  name: 'AttachmentSourceButton',
  components: { FileSelectorModal },
  props: {
    fileFilter: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menuOpen: false,
    showLibrary: false
  }),
  methods: {
    openUploader() {
      this.menuOpen = false
      this.$refs.uploader.click()
    },
    openLibrary() {
      this.menuOpen = false
      this.showLibrary = true
    },
    handleFiles(event) {
      const files = Array.from(event.target.files || [])
      this.$emit('files-selected', files)
      event.target.value = ''
    },
    selectLibraryFile(file) {
      this.showLibrary = false
      this.$emit('library-file-selected', file)
    }
  }
}
</script>

<style scoped>
.text-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: 1px solid #E5E8EF;
  cursor: pointer;
  border-radius: 7px;
  padding: 5px 10px;
  font-size: 12px;
  color: #374151;
  transition: background 0.12s;
}

.text-action-btn:hover {
  background: #F3F4F6;
}
</style>

<!-- Sin scoped: el contenido de v-menu se renderiza fuera del componente (detach) -->
<style>
.attachment-menu {
  border: 1px solid #E5E8EF;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.08), 0 1px 3px rgba(17, 24, 39, 0.06) !important;
  overflow: hidden;
}

.attachment-menu__panel {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 260px;
  padding: 6px;
}

.attachment-menu__item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s;
}

.attachment-menu__item:hover {
  background: #F3F6FC;
}

.attachment-menu__item:focus-visible {
  outline: 2px solid #2D4B95;
  outline-offset: -2px;
}

.attachment-menu__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #EAEFFA;
  transition: background 0.12s;
}

.attachment-menu__item:hover .attachment-menu__icon {
  background: #DCE5F7;
}

.attachment-menu__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.3;
}

.attachment-menu__title {
  font-size: 13px;
  font-weight: 500;
  color: #1F2937;
}

.attachment-menu__desc {
  margin-top: 1px;
  font-size: 11.5px;
  color: #6B7280;
}
</style>